import React, { memo, useEffect, useRef } from "react";
import styled from "../../css/components/modal.module.scss";
import { IoMdClose } from "react-icons/io";
import useClickOutside from "../../hooks/useClickOutside/useClickOutside";

function Modal({
  children,
  onClose,
  minwidth,
  maxWidth,
  outerStyle,
  innerBodyStyle,
}) {
  const modalRef = useRef();
  useClickOutside(modalRef, () => {
    onClose();
  });
  useEffect(() => {
    if (typeof window !== "undefined" && window.document) {
      const scrollPosition = window.scrollY || window.pageYOffset;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = "100%";

      return () => {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        window.scrollTo(0, scrollPosition);
      };
    }
  }, []);

  const handleOnClose = () => {
    if (typeof window !== "undefined" && window.document) {
      const scrollPosition = parseInt(document.body.style.top || "0", 10) * -1;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollPosition);
    }
    onClose();
  };
  return (
    <div className={styled.backdrop}>
      <div
        ref={modalRef}
        className={[styled.outer, "no-scrollbar", outerStyle].join(" ")}
        style={{
          minwidth: minwidth ? minwidth : undefined,
          maxWidth: maxWidth ? maxWidth : undefined,
        }}
      >
        <div className={styled.close_icon_outer}>
          <div onClick={handleOnClose}>
            <IoMdClose fontSize={20} />
          </div>
        </div>
        <div className={[styled.modal_body_outer, innerBodyStyle].join(" ")}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default memo(Modal);
